import { useEffect, useState } from "react";
import { FormProps } from "../../components/form/interface/formInterface";
import AdminAPI from "../../api/admin";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import Page from "../../components/table/paging";
import ButtonStyle from "../../components/style/button.component";

import { useSetRecoilState } from "recoil";
import { loadingState } from "../../recoil/loading.atom";
import SmallForm from "../../components/form/small_form";
import { ISearchBanner } from "./interface/interface";

const SearchBanner = () => {
  const [bannerList, setBannerList] = useState<ISearchBanner[]>([]);
  const [id, setId] = useState(0);
  const [order, setOrder] = useState(0);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [url, setUrl] = useState("");
  const [startAt, setStartAt] = useState("");
  const [closeAt, setCloseAt] = useState("");
  const setIsLoading = useSetRecoilState(loadingState);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mode, setMode] = useState("I");
  const [type, setType] = useState("BM");
  const typeList = [{ value: "BM" }, { value: "RUNNER" }];

  const formData: FormProps = {
    title: "상세 정보",
    form: [
      {
        value: title,
        setValue: setTitle,
        label: "메인 텍스트",
        width: "100%",
        type: "input",
      },
      {
        value: subTitle,
        setValue: setSubTitle,
        label: "서브 텍스트",
        width: "100%",
        type: "input",
      },
      {
        value: type,
        setValue: setType,
        options: typeList,
        label: "배너타입",
        width: "100%",
        type: "select",
      },
      {
        value: startAt,
        setValue: setStartAt,
        label: "시작일시",
        width: "100%",
        type: "date",
      },
      {
        value: closeAt,
        setValue: setCloseAt,
        label: "종료일시",
        width: "100%",
        type: "date",
      },
      {
        value: url,
        setValue: setUrl,
        label: "배너 클릭 시 이동하는 링크",
        width: "100%",
        type: "input",
      },
      {
        value: order,
        setValue: setOrder,
        label: "순서",
        width: "100%",
        type: "input",
      },
    ],
  };

  const headers = [
    {
      text: "id",
      align: "start",
      sortable: false,
      value: "id",
    },
    {
      text: "순서",
      align: "start",
      sortable: false,
      value: "order",
    },
    {
      text: "메인 텍스트",
      align: "start",
      sortable: false,
      value: "title",
    },
    {
      text: "서브 텍스트",
      align: "start",
      sortable: false,
      value: "subTitle",
    },
    {
      text: "타입",
      align: "start",
      sortable: false,
      value: "type",
    },
    {
      text: "링크",
      align: "center",
      sortable: false,
      value: "url",
    },
    {
      text: "시작일시",
      align: "center",
      sortable: false,
      value: "startAt",
    },
    {
      text: "종료일시",
      align: "center",
      sortable: false,
      value: "closeAt",
    },
  ];

  const addForm = () => {
    setMode("I");
    setId(0);
    setTitle("");
    setType("BM");
    setSubTitle("");
    setUrl("");
    setStartAt("");
    setCloseAt("");
  };

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  function formatJsonDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  const add = async () => {
    const body = {
      title,
      subTitle,
      url,
      startAt: formatJsonDate(startAt),
      closeAt: formatJsonDate(closeAt),
      type,
      order,
    };
    if (type === "RUNNER") {
      const runner = bannerList.find((item) => item.type === "RUNNER");
      if (runner) {
        alert("러너 타입 배너는 최대 하나만 생성 가능합니다. ");
        return;
      }
    }
    if (window.confirm("신규등록 하시겠습니까?")) {
      setIsLoading(true);
      try {
        const res = await AdminAPI.createSearchBanner(body);
        if (res) {
          alert("신규 등록 되었습니다.");
          getDataList();
          addForm();
          setIsLoading(false);
        }
      } catch (e) {
        alert(e);
        setIsLoading(false);
      }
    }
  };

  const remove = async () => {
    if (window.confirm("삭제 하시겠습니까?")) {
      setIsLoading(true);
      const res = await AdminAPI.deleteSearchBanner(id);
      if (res && res.status === 200) {
        alert("삭제 되었습니다.");
        getDataList();
        addForm();
      }
      setIsLoading(false);
    }
  };

  const save = async () => {
    const body = {
      title,
      subTitle,
      url,
      startAt: formatJsonDate(startAt),
      closeAt: formatJsonDate(closeAt),
      type,
      order,
    };
    setIsLoading(true);
    try {
      const res = await AdminAPI.updateSearchBanner(id, body);
      if (res) {
        alert("저장 되었습니다.");
        getDataList();
        addForm();
        setIsLoading(false);
      }
    } catch (e: any) {
      alert(e.message);
      setIsLoading(false);
    }
  };

  const setDetails = (item: ISearchBanner) => {
    if (item.type === "RUNNER") {
      setMode("S");
    } else {
      setMode("U");
    }
    setId(item.id);
    setTitle(item.title);
    setSubTitle(item.subTitle);
    setUrl(item.url);
    setOrder(item.order);
    setStartAt(item.startAt);
    setCloseAt(item.closeAt);
    setType(item.type);
  };

  const getDataList = async () => {
    const res = await AdminAPI.getSearchBannerList();
    if (res && res.status === 200) {
      const updatedData = res.data.map((item: ISearchBanner) => ({
        ...item,
        closeAt: formatDate(item.closeAt),
        startAt: formatDate(item.startAt),
      }));
      const totalPages = Math.ceil(updatedData.length / 10);
      setTotalPages(totalPages);
      setBannerList(updatedData);
    } else {
      setBannerList([]);
    }
  };
  useEffect(() => {
    getDataList();
  }, []);
  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          지도 배너 관리
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="10px"
        >
          <Table
            headers={headers}
            currentPage={currentPage}
            dataList={bannerList}
            setDetail={setDetails}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={bannerList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
        <DivStyle
          marginBottom="50px"
          width="95%"
          display="flex"
          justify_content="flex-end"
        >
          <ButtonStyle
            border="none"
            backgroundColor="#1976D2"
            width="85px"
            height="40px"
            color="white"
            borderRadius="5px"
            onClick={() => addForm()}
          >
            신규 등록
          </ButtonStyle>
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            add={add}
            save={save}
            remove={remove}
            mode={mode}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default SearchBanner;
